import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { toast } from "sonner";

export default function Users({ users }) {
  return (
    <div className="rounded-xl border border-border bg-card divide-y divide-border overflow-hidden" data-testid="admin-users">
      {users.map((u) => (
        <div key={u.id} className="flex items-center gap-3 p-4">
          <div className="h-9 w-9 rounded-full bg-gradient-to-br from-indigo-500 to-purple-500 flex items-center justify-center text-white text-xs font-semibold">{u.name[0]}</div>
          <div className="flex-1 min-w-0"><div className="text-sm font-medium truncate">{u.name}</div><div className="text-xs text-muted-foreground truncate">{u.email}</div></div>
          <Select value={u.role} onValueChange={() => toast.info("Role changes require platform-admin approval")}>
            <SelectTrigger className="w-32 h-8 text-xs capitalize" data-testid={`user-role-${u.id}`}><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="candidate">Candidate</SelectItem>
              <SelectItem value="recruiter">Recruiter</SelectItem>
              <SelectItem value="admin">Admin</SelectItem>
            </SelectContent>
          </Select>
        </div>
      ))}
    </div>
  );
}
